import { SIZE } from '@app/constants'

export const commonControlProps = {
  allowClear: true,
  size: SIZE.small
} as const
